//To be use as a top container
const topcontainer = (props) => props.children;

export default topcontainer;
